import { ref } from "vue";
import { defineStore } from "pinia";
import { getUnreadSiteMessage } from "@/api/affiliate-site-message";

export const siteMessageStore = defineStore("siteMessageStore", () => {
  const unreadCount = ref(0);
  async function loadUnreadCount() {
    try {
      const { data } = await getUnreadSiteMessage();
      unreadCount.value = Number(data) || 0;
    } catch (e) {
      unreadCount.value = 0;
    }
  }
  return { unreadCount, loadUnreadCount };
});
